import { allAppsWidth } from '../../Common/ReportsTableSummary';
export const headerConfigBasedOnReportBy = {
  hosting: ['Cloud', 'Server', 'Data Center'],
  type: ['New sales', 'Renewals', 'Upgrades', 'Refunds'],
  region: ['Americas', 'APAC', 'EMEA', 'Unknown'],
  country: ['#1', '#2', '#3', 'Others']
};
const getSalesOrEvaluationsHead = (reportName, reportBy) => {
  const headerConfig = headerConfigBasedOnReportBy[reportBy];
  const style = {
    width: "".concat((100 - allAppsWidth) / (headerConfig.length + 1), "%")
  };
  return {
    cells: [{
      key: 'appName',
      content: 'App',
      isSortable: true,
      style: {
        width: "".concat(allAppsWidth, "%")
      }
    }, ...headerConfig.map(value => ({
      key: value,
      content: value,
      isSortable: true,
      style
    })), {
      key: 'total',
      content: "All ".concat(reportName),
      isSortable: true,
      style
    }]
  };
};
export default getSalesOrEvaluationsHead;